define([
  'js/aofl-js/0.8.0/aofl-modules/__build/aofljs.min'
], function RiqUserModelServiceModule(aoflModules) {
  'use strict';
  var storeService = aoflModules.store;

  var riqUserModelService = function(
    riqApiService,
    cdnAssetService,
    $rootScope,
    riqAuthService,
    riqAnalyticsService
  ) {
    var _this = this;
    var cdnBaseUrl = $rootScope.cdnBaseUrl;

    // Add endpoint for account upgrade options,
    // get current subscription, purchase subscription
    riqApiService.setApiEndpoints({
      getUserAccount: 'user_get',
      updateUserAccount: 'user_update',
      getUserProfile: 'profile_get',
      saveUserProfile: 'profile_update',
      loginAs: 'profile_swap',
      getAvatarOptions: 'avatar_get',
      checkPassword: 'account_validate',
      submitRedeemCode: 'code_redeem',
      connectToClassroom: 'group_add_profile',
      cancelAccount: 'account_validate_cancel',
      updateAccount: 'account_update',
      updateUserBillingInfo: 'user_update_payment_info',
      getAccountBillingInfo: 'account_get_info',
      onboardingAddProfile: 'onboarding_add_profile'
    });

    var getUserAccount = function getUserAccount(data) {
      return riqApiService.get('getUserAccount', data);
    };

    var updateUserAccount = function updateUserAccount(data) {
      return riqApiService.get('updateUserAccount', data);
    };

    var getUserProfile = function getUserProfile(
      profileDetails,
      profileUuid,
      groupUuid,
      _cache
    ) {
      var state = storeService.getState();
      var profileId = profileUuid || state.profile.profileUuid;
      var groupId = groupUuid || state.profile.groupUuid;
      // available options => 'name', 'avatar', 'invitation_status',
      // 'contact_email', 'inactive', 'profile_grade_level', 'created_date',
      // 'active_reading_level', 'active_reading_level_type', 'teacher_school',
      // 'teacher_role', 'redeem_code', 'csv_imported'
      var detailsArray = [
        'name',
        'avatar',
        'profile_grade_level',
        'active_reading_level',
        'active_reading_level_type'
      ].concat(profileDetails || []);
      return riqApiService.get(
        'getUserProfile',
        {
          groupUuid: groupId,
          profileUuids: [profileId],
          profileDetails: detailsArray
        },
        _cache
      );
    };

    var saveUserProfile = function saveUserProfile(
      data,
      profileUuid,
      isOnboarding
    ) {
      var uuid = profileUuid || storeService.getState().profile.profileUuid;
      const endpoint = isOnboarding
        ? 'onboardingAddProfile'
        : 'saveUserProfile';

      return riqApiService
        .post(endpoint, {
          profileUuid: uuid,
          profileDetails: data
        })
        .then(function(payload) {
          if (!isOnboarding) {
            riqAnalyticsService.enqueueEvent({
              eventType: 'com.aofl.readingiq.profile.update',
              payload: payload.tracking
            });
          }
          return payload;
        });
    };

    var updateAvatar = function updateAvatar(profileUuid, avatar) {
      return riqApiService
        .post('saveUserProfile', {
          profileUuid: profileUuid,
          profileDetails: {avatar: avatar}
        })
        .then(function(payload) {
          riqAnalyticsService.enqueueEvent({
            eventType: 'com.aofl.readingiq.profile.update',
            payload: payload.tracking
          });
          return payload;
        });
    };

    var updateUserBillingInfo = function updateUserBillingInfo(data) {
      return riqApiService.get('updateUserBillingInfo', data);
    };

    var loginAs = function loginAs(profileUuid) {
      return riqApiService
        .get('loginAs', {profileUuid: profileUuid}, false)
        .then(function(profileData) {
          const userStateUpdate = {};
          const newUserData = profileData.tracking.to;
          // eslint-disable-next-line no-undef
          const newUserDesc = profileData.tracking?.to?.userDescription;

          Object.keys(newUserData).forEach(function(key) {
            if (newUserData[key]) {
              if (key === 'masterUuid') {
                userStateUpdate.masterUserUuid = newUserData[key];
              } else {
                userStateUpdate[key] = newUserData[key];
              }
            }
          });

          storeService.commit([
            {
              stateAlias: 'user',
              mutationId: 'update',
              payload: {
                userDescription: newUserDesc
              }
            },
            {
              stateAlias: 'profile',
              mutationId: 'setUserProfile',
              payload: {
                userUuid: userStateUpdate.userUuid,
                profileUuid: userStateUpdate.profileUuid
              }
            }
          ]);

          return profileData;
        });
    };

    var logoutUser = function logoutUser() {
      return riqAuthService.logout();
    };

    var _handleGetAvatarOptions = function getAvatarOptions(payload) {
      return payload.avatars
        .map(function(av) {
          return Object.assign({}, av, {
            url:
              cdnBaseUrl +
              cdnAssetService.getAvatarImagePath({avatarId: av.avatarId})
          });
        })
        .sort(function(a, b) {
          return a.avatarId - b.avatarId;
        });
    };

    var getAvatarOptions = function getAvatarOptions() {
      return riqApiService
        .get('getAvatarOptions')
        .then(_handleGetAvatarOptions)
        .catch(function(error) {
          throw error;
        });
    };

    var checkPassword = function checkPassword(password) {
      return riqApiService.get('checkPassword', {password: password});
    };

    var saveUserEmail = function saveUserEmail(oldEmail, newEmail) {
      var userUuid = storeService.getState().user.userUuid;
      return riqApiService.get(
        'updateAccount',
        {
          userUuid: userUuid,
          currentUsername: oldEmail,
          username: newEmail
        },
        false
      );
    };

    var saveUserPhoneNumber = function saveUserPhoneNumber(
      oldPhoneNumber,
      newPhoneNumber
    ) {
      var userUuid = storeService.getState().user.userUuid;
      return riqApiService.get(
        'updateAccount',
        {
          userUuid: userUuid,
          currentUsername: oldPhoneNumber,
          username: newPhoneNumber
        },
        false
      );
    };

    var saveName = function saveName(firstName, lastName) {
      var userUuid = storeService.getState().user.userUuid;
      return riqApiService.userGet(
        'updateUserAccount',
        {
          userUuid: userUuid,
          userDetails: {
            firstName: firstName,
            lastName: lastName
          }
        },
        false
      );
    };

    var saveUserPassword = function saveUserPassword(oldPassword, newPassword) {
      var userUuid = storeService.getState().user.userUuid;
      return riqApiService.get(
        'updateAccount',
        {
          userUuid: userUuid,
          currentPassword: oldPassword,
          password: newPassword
        },
        false
      );
    };

    var submitRedeemCode = function submitRedeemCode(userUuid, redeemCode) {
      return riqApiService.get('submitRedeemCode', {
        userUuid: userUuid,
        redeemCode: redeemCode
      });
    };

    var connectToClassroom = function connectToClassroom(profileUuid) {
      return riqApiService.get('connectToClassroom', {
        profileUuid: profileUuid
      });
    };

    var cancelAccount = function cancelAccount(data) {
      return riqApiService.get('cancelAccount', data);
    };

    var getAccountBillingInfo = function getAccountBillingInfo() {
      var userUuid = storeService.getState().user.userUuid;
      return riqApiService.get(
        'getAccountBillingInfo',
        {userUuid: userUuid},
        false
      );
    };

    _this.getUserAccount = getUserAccount;
    _this.updateUserAccount = updateUserAccount;
    _this.getUserProfile = getUserProfile;
    _this.saveUserEmail = saveUserEmail;
    _this.saveUserPhoneNumber = saveUserPhoneNumber;
    _this.saveUserPassword = saveUserPassword;
    _this.saveUserProfile = saveUserProfile;
    _this.updateAvatar = updateAvatar;
    _this.loginAs = loginAs;
    _this.logoutUser = logoutUser;
    _this.getAvatarOptions = getAvatarOptions;
    _this.checkPassword = checkPassword;
    _this.submitRedeemCode = submitRedeemCode;
    _this.connectToClassroom = connectToClassroom;
    _this.cancelAccount = cancelAccount;
    _this.updateUserBillingInfo = updateUserBillingInfo;
    _this.getAccountBillingInfo = getAccountBillingInfo;
    _this.saveName = saveName;
  };

  return riqUserModelService;
});
